import { VaultStatsWithDepositor } from 'src/hooks/vaults/useVaultStatsWithDepositors';
import { useSpotMarkets } from 'src/hooks/spotMarkets/useSpotMarkets';
import { useVaultDepositorHistories } from 'src/hooks/query/vaults/base/useVaultDepositorHistories';

import {
	getAuthorityVaultBalance,
	getTimeWeightedRoi,
} from 'src/utils/vault/math';
import useGetOraclePriceForMarket from 'src/hooks/useGetOraclePriceForMarket';
import { MarketId } from '@velocity-exchange/common';
import { BigNum, QUOTE_PRECISION_EXP } from '@velocity-exchange/sdk';

export const useRoiForVault = (
	vaultStatAndDepositor: VaultStatsWithDepositor
) => {
	const spotMarkets = useSpotMarkets();
	const uiVaultConfig = vaultStatAndDepositor.vaultStat.uiVaultConfig;
	const { data: historiesLookup } = useVaultDepositorHistories();
	const vaultDepositorHistory =
		historiesLookup?.[uiVaultConfig.vaultPubkeyString] ?? [];
	const isNotionalGrowthStrategy = uiVaultConfig.isNotionalGrowthStrategy;
	const getOraclePriceForMarket = useGetOraclePriceForMarket();

	const authorityVaultBalance = getAuthorityVaultBalance(
		vaultStatAndDepositor.depositor
			? [vaultStatAndDepositor.depositor.vaultDepositor]
			: [],
		vaultStatAndDepositor.vaultStat,
		'base'
	);

	function getCurrentUserNotionalBalance() {
		const oraclePrice = getOraclePriceForMarket(
			MarketId.createSpotMarket(uiVaultConfig.depositAsset)
		);

		if (!oraclePrice) return BigNum.zero(QUOTE_PRECISION_EXP);

		const currentUserNotionalBalance = authorityVaultBalance
			.mul(oraclePrice)
			.shiftTo(QUOTE_PRECISION_EXP);

		return currentUserNotionalBalance;
	}

	const currentUserNotionalBalance = getCurrentUserNotionalBalance();

	const timeWeightedRoi = getTimeWeightedRoi(
		vaultStatAndDepositor.depositor?.vaultDepositor,
		vaultStatAndDepositor.vaultStat.vaultAccount,
		vaultStatAndDepositor.vaultStat.uiVaultConfig,
		vaultDepositorHistory ?? [],
		isNotionalGrowthStrategy
			? QUOTE_PRECISION_EXP
			: spotMarkets[uiVaultConfig.depositAsset].precisionExp,
		isNotionalGrowthStrategy
			? currentUserNotionalBalance
			: authorityVaultBalance
	);

	return timeWeightedRoi;
};
